export default {"src":"/_next/static/media/tooth_64.c71d50e3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};